import React from 'react'

import Negative from 'app/assets/icons/listing/negative.svg'
import Positive from 'app/assets/icons/listing/positive.svg'
import IconButton, { IconButtonProps } from 'app/components/base/IconButton'
import { QuantityInputProps } from 'app/components/base/QuantityInput/QuantityInput'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

type UseQuantityProps = Pick<
  QuantityInputProps,
  'value' | 'onChange' | 'maxValue' | 'disabled'
>

const useQuantity = ({
  value,
  maxValue = 1,
  disabled,
  onChange = () => {}
}: UseQuantityProps) => {
  return {
    negative: (
      <Sign
        icon={<Negative />}
        disabled={disabled || Number(value) <= 1}
        onClick={() => onChange(Number(value) - 1)}
        ariaLabel="Decrease quantity"
      />
    ),
    positive: (
      <Sign
        icon={<Positive />}
        disabled={disabled || Number(value) >= maxValue}
        onClick={() => onChange(Number(value) + 1)}
        ariaLabel="Increase quantity"
        {...(IS_NATIVE_APP && { sx: { mt: 0.5 } })}
      />
    )
  }
}

type SignProps = {
  icon: React.ReactNode
  sx?: IconButtonProps['sx']
  onClick: () => void
  disabled: boolean
  ariaLabel?: string
}

const Sign: RFC<SignProps> = ({ icon, onClick, disabled, sx, ariaLabel }) => {
  return (
    <IconButton
      sx={{
        width: 34,
        height: 34,
        p: 0,
        ...sx
      }}
      disabled={disabled}
      onPress={onClick}
      aria-label={ariaLabel}
    >
      {icon}
    </IconButton>
  )
}

export default useQuantity
